import { apiClient } from '../../../shared/services/apiClient';
import { AuditAction, AuditLog } from '../types/securityLogs.types';

interface AuditLogsResponse {
    logs: AuditLog[];
    total: number;
    page: number;
    pages: number;
}

export const fetchAuditLogs = async (
    page = 1,
    limit = 50,
    action?: AuditAction | ''
): Promise<AuditLogsResponse> => {
    const params: Record<string, string | number> = { page, limit };
    if (action) params.action = action;
    const { data } = await apiClient.get<AuditLogsResponse>(
        '/super-admin/audit-logs',
        { params }
    );
    return data;
};
